import { axios } from "@/client/libs/axios";

export type Organization = {
  id: string;
  name: string;
  slug: string;
  createdAt: string;
  users: OrganizationUser[];
  _count: {
    users: number;
    resumes: number;
  };
};

export type OrganizationUser = {
  id: string;
  role: string;
  user: {
    id: string;
    name: string;
    email: string;
    picture: string | null;
  };
};

export const createOrganization = async (name: string) => {
  const response = await axios.post<Organization>("/organization", { name });
  return response.data;
};

export const getOrganizations = async () => {
  const response = await axios.get<Organization[]>("/organization");
  return response.data;
};

export const getOrganization = async (id: string) => {
  const response = await axios.get<Organization>(`/organization/${id}`);
  return response.data;
};

export const addMember = async (id: string, email: string, role = "member") => {
  const response = await axios.post(`/organization/${id}/member`, { email, role });
  return response.data;
};

export const removeMember = async (id: string, memberId: string) => {
  const response = await axios.delete(`/organization/${id}/member/${memberId}`);
  return response.data;
};
